import './ccf-disable-call-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfDisableCallIconProps extends SvgIconProps  {}
/**
 * Icon wrapper for disbale call icon
 * @param props-CcfDisableCallIconProps
 * @returns 
 * @example CcfDisableCallIcon()
 */
export function CcfDisableCallIcon(props: CcfDisableCallIconProps) {
  return (
    <SvgIcon {...props}>
       <g id="ic_disabled_call" clip-path="url(#clip-ic_disabled_call)">
    <g id="li_voice_call" transform="translate(-3 -3)">
      <rect id="Rectangle_80985" data-name="Rectangle 80985" width="30" height="30" rx="4" fill="#526b7a" opacity="0"/>
      <g id="Channel_Type" data-name="Channel Type" transform="translate(7.741 7.5)">
        <g id="phone-outbound">
          <path id="Path_12422" data-name="Path 12422" d="M9.165-32.276s-.639,1.032-.7,1.12-.183.347-.777.172a8.636,8.636,0,0,1-3.524-2.542,8.965,8.965,0,0,1-2.46-3.641c-.17-.615.081-.743.166-.8s1.084-.721,1.084-.721c.672-.407-.088-2.149-1.314-2.987-.906-.619-1.3-.559-1.683-.254a9.794,9.794,0,0,0-1.651,1.748,1.7,1.7,0,0,0-.289,1.193A10.187,10.187,0,0,0-.632-35.241,17.953,17.953,0,0,0,2.21-31.506a17.6,17.6,0,0,0,3.615,2.936,9.449,9.449,0,0,0,3.631,1.394,1.574,1.574,0,0,0,1.155-.3A9.773,9.773,0,0,0,12.3-29.179c.3-.393.353-.8-.246-1.739C11.245-32.185,9.559-32.97,9.165-32.276Z" transform="translate(2 42.156)" fill="#526b7a" opacity="0.397"/>
        </g>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfDisableCallIcon;
